export default () => {
    const shopList = document.getElementById('inputProjet') as HTMLSelectElement;
    const reviewPath = shopList?.getAttribute('data-review-path');

    if(!reviewPath) return;

    shopList?.addEventListener('change', () => {
        document.location.href = reviewPath + shopList.value;
    });
}
